












































import { Component, Prop, Vue } from "vue-property-decorator";
import mock from "../mock/News";
import { RequestStatus } from "../utils/constans";
import { formatBackTime } from "../utils/common";
import { iPersonInfo, iNew, iAward } from "../typings/personinfo";
import $api from "../api";

@Component
export default class BasicInfo extends Vue {
  private requestStatus: number = 0;

  private newsList: iNew[] = [];
  private enNewsList: iNew[] = [];

  mounted() {
    this.getRecentNews();
  }

  getRecentNews() {
      let res = mock.News;
      this.requestStatus += 1;
      const list: iNew[] = res as any;
      list.sort(this.sortNews)
      list.reverse();
      list.map((record: iNew) => {
        if (
          (record.language === "英语") ||
          record.id == 1
        ) {
          if (record.id == 1) {
            this.enNewsList.unshift(record);
          } else {
            this.enNewsList.push(record);
          }
        }
        if (
          (record.language === "汉语") ||
          record.id == 149 || record.id == 150
        ) {
          if (record.id == 149 || record.id == 150) {
            // this.newsList.unshift(record);
          } else {
            this.newsList.push(record);
          }
        }
      });
  }

  sortNews(a: iNew, b: iNew){
    let temp = a.time.split("-")
    let aTime = Number(temp[2]) + Number(temp[1]) * 100 + Number(temp[0]) * 10000
    temp = b.time.split("-")
    let bTime = Number(temp[2]) + Number(temp[1]) * 100 + Number(temp[0]) * 10000
    return aTime - bTime
  }

  handleNewDetail(item: any) {
    localStorage.setItem("new-datail-cache", JSON.stringify(item));
    this.$router.push({
      name: "NewDetail",
      params: {
        item
      }
    });
  }
}
